"use strict"

module.exports = require("./stream/stream")
